import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import FAQS from "../../../MyComponents/FooterPages/newfaq"
import heroContent from "../HeroContent-GDesign";
import leftimg from "../../../assets/figmaleftimg.png";
import rightimg from "../../../assets/figmarightimg.png";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
import FunActivities from "../../../MyComponents/FunActivities";
import BenefitsDataImg1 from "../../../assets/figma-benefit-img1.png";
import BenefitsDataImg2 from "../../../assets/figma-benefit-img2.png";
import BenefitsDataImg3 from "../../../assets/figma-benefit-img3.png";
import BenefitsDataImg4 from "../../../assets/figma-benefit-img4.png";
import BenefitsDataImg5 from "../../../assets/figma-benefit-img5.png";
import BenefitsDataImg6 from "../../../assets/figma-benefit-img6.png";
import BenefitsDataImg7 from "../../../assets/figma-benefit-img7.png";
import BenefitsDataImg8 from "../../../assets/figma-benefit-img8.png";
import BenefitsDataImg9 from "../../../assets/figma-benefit-img9.png";
import FunactivitiesImg1 from "../../../assets/figmaFun-img1.png";
import FunactivitiesImg2 from "../../../assets/figmaFun-img2.png";
import FunactivitiesImg3 from "../../../assets/figmaFun-img3.png";

import LearningStyle from "../../../MyComponents/LearningStyle"
import VideoSection from "../../../MyComponents/VideoSection";
import Testimonials from "../../../MyComponents/Testimonials";
 const beginnerModules = [
    {
      title: "Module 1",
      activities: "06",
      classes: "03",
      description:" Figma Fundamentals Learn Figma basics—shapes, text, and UI design principles. Create icons, buttons, and simple layouts.",
    },
    {
      title: "Module 2",
      activities: "06",
      classes: "02",
      description:"App Design & Prototyping- Design full mobile app interfaces with user flows and interactive prototypes that look great and work well.",
    },
    {
      title: "Module 3",
      activities: "06",
      classes: "01",
      description:" Website Design -Build responsive desktop and mobile websites. Final project: design a complete educational site.",
    },
];    

  const benefitsData = [
      {
        title: "UI/UX Fundamentals",
        description: "Learn design basics and user flow.",
        icon: BenefitsDataImg1,
      },
      {
        title: "Design Principles",
        description: "Layout, color, and typography.",
        icon: BenefitsDataImg2,
      },
      {
        title: "Figma  Basics",
        description: "Learn to use Figma’s full toolkit to bring your ideas to life.",
        icon: BenefitsDataImg3,
      },
      {
        title: "Advanced Figma Design",
        description: "Prototyping and components",
        icon: BenefitsDataImg4,
      },
      {
        title: "Figma Assets & Animations",
        description: "Libraries and transitions",
        icon: BenefitsDataImg5,
      },
      {
        title: "Build  Prototyping",
        description: "Turn your static designs into clickable, real-world simulations.",
        icon: BenefitsDataImg6,
      },
      {
        title: "Design a Pro Portfolio",
        description: "Highlight your best work to attract clients and job offers.",
        icon: BenefitsDataImg7,
      },
      {
        title: "Website Design",
        description: "Responsive layouts and wireframes.",
        icon: BenefitsDataImg8,
      },
      {
        title: "Mobile App Design",
        description: "App UI and user experience",
        icon: BenefitsDataImg9,
      },
    ];
    const activitiesData = [
        {
          title: "Mobile App Design",
          image: FunactivitiesImg1,
        },
        {
          title: "Website Layout",
          image: FunactivitiesImg2,
        },
        {
          title: "Game Interface ",
          image: FunactivitiesImg3,
        }
       
      ];
     const videoData = {
    title: "Watch Our Introduction Video",
    description:
      "Discover how kids can turn their creativity into stunning designs! In this video, we’ll introduce fun tools, basic design tips, and exciting projects like logos, flyers, and digital art. Whether you're just starting out or love being creative, this is the perfect place to begin your design journey.",

      
    videoSrc: "", // Replace with the actual video URL
  };
const Figma = () => {
  const Figmapage = heroContent.figmasection;
  return (
    <>
       <GuestNav/>
     <Hero2
        titlePart1={Figmapage.titlePart1}
        // titlePart2={adobepage.titlePart2}
        description={Figmapage.description}
        buttonText={Figmapage.buttonText}
        leftImage={leftimg}
        rightImage={rightimg}
      />
       <CourseTimeline
        title="Course Structure and Syllabus"
        modules={beginnerModules}
      />
       <Benefits
        title="How Students Can Benefit From Abacus"
        benefitsData={benefitsData}
      />
       <FunActivities
              mainTitle="Learn Corel Draw"
              subTitle="With 40+ Fun Activities"
              activities={activitiesData}
            />
        <LearningStyle/>
         <VideoSection
        title={videoData.title}
        description={videoData.description}
        videoSrc={videoData.videoSrc}
      />
      <Testimonials/>
      <FAQS/>
       <Footer/>
    </>
  )
}
export default Figma